export default __webpack_public_path__ + "static/media/info_img.774e1db2.svg";